/**
 * [发号福利 标签切换]
 */
if ($('.js-tab').length) {
    $('.js-tab').each(function() {
        var _this = $(this);
        var $tab = _this.find('.tab-pn').slick({
            dots: false,
            autoplay: false,
            arrows: false
        });
        _this.find('.tab li:eq(0)').addClass('current');
        _this.find('.tab li').click(function() {
            var i = $(this).index();
            $(this).addClass('current').siblings().removeClass('current');
            $tab.slickGoTo(i);
        });
        $('.hao-welfare .slick-slide').show();
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/component/hao.js
// module id = 3
// module chunks = 0